import { render, staticRenderFns } from "./OdontogramModeSettings.vue?vue&type=template&id=3c4e01a1&scoped=true"
import script from "./OdontogramModeSettings.vue?vue&type=script&lang=js"
export * from "./OdontogramModeSettings.vue?vue&type=script&lang=js"
import style0 from "./OdontogramModeSettings.vue?vue&type=style&index=0&id=3c4e01a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4e01a1",
  null
  
)

export default component.exports